export default __webpack_public_path__ + "static/media/wifiman.bd0c0d80.png";